import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';

const styles = theme => ({

});

class DisableContactDataDialog extends React.Component {

  onEnterPressed = (ev) => {
    if (ev.key === 'Enter') {
      this.disableOption();
      ev.preventDefault();
    }
  }

  render() {
    const { fullScreen } = this.props;
    return (
      <Dialog fullScreen={fullScreen} open={this.props.open}>
        <DialogTitle>{"Kontaktdaten ausblenden?"}</DialogTitle>
        <DialogContent style={{ paddingLeft: 20, paddingRight: 20 }}>
          <DialogContentText>Bitte beachten Sie, dass den Teilnehmern während der Veranstaltung sowohl E-Mail als auch Handynummer übermittelt werden. Für die Anmeldephase können Sie den Kontakt auf ein Medium beschränken.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.props.onClose(false)} variant="contained">Abbrechen</Button>
          <Button onClick={this.props.onDisableOption} variant="contained" color="primary" autoFocus>Option deaktivieren</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

DisableContactDataDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDisableOption: PropTypes.func.isRequired,
};

export default withMobileDialog()(withStyles(styles, { withTheme: true })(DisableContactDataDialog));
